// LIBRARIES

import styled from "styled-components";

//MISC

import { BORDER_RADIUS, DEVICE_TYPE, MARGIN } from "constants/variables";

export const ImgWrap = styled.div`
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 1em;
    border-radius: 1em;
    margin-bottom: 1em;
`
export const EventCardContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
    
  gap: ${MARGIN.max4};
`;

export const ImgCard = styled.img`
  border-radius: ${BORDER_RADIUS.radius24};
  width: 100%;
  height: 264px;
  object-fit: contain;
  background-size: cover;
  background-position: center;
  margin-bottom: ${MARGIN.fix24};
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    height: 165px;
  }
`;

export const TitleText = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin-bottom: ${MARGIN.max4};
`;

export const Subtitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.max8};
`;

export const WrapperButton = styled.div`
  height: 42px;
  width: 129px;
  margin-top: ${MARGIN.fix16};
`;

export const DsuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.max8};
  align-items: center;
`;

export const DsuImg = styled.img`
  width: 40px;
  height: 40px;
  background-size: cover;
  background-position: center;
`;

export const ImgSubtitle = styled.img`
  width: 24px;
  height: 24px;
`;
